import { useIntl } from "react-intl";

import TabsContent from "@/components/adg4/tabs-content/src/tabs-content";
import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { DataEventProps } from "@/libraries/wpl/foundations/src/data-event-props";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

const ProjectManagementTabContent = () => {
    const intl = useIntl();

    const useNewScreenshots = checkFeatureFlagGate(
        featureFlags.gwp9214HomepageScreenshots
    );

    const cardCtaText = intl.formatMessage({
        id: "HomePageTemplateV2.tab.projManagement.card.linkText",
        defaultMessage: "Try it out"
    });

    const cardDataEventProps: DataEventProps = {
        "data-product-key": "home",
        "data-event-component": "linkButton",
        "data-event-container": "cardSection",
        "data-event": "clicked",
        "data-label": cardCtaText,
        "data-label-english": "Try it out"
    };

    const cardOneCtaUrl = useLocalizedHref("/software/jira/templates/scrum");
    const cardTwoCtaUrl = useLocalizedHref("/software/jira/templates/kanban");
    const cardThreeCtaUrl = useLocalizedHref(
        "/agile/project-management/gantt-chart"
    );

    return (
        <TabsContent
            className="homepage-tabs-content"
            contentList={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.header",
                        defaultMessage: "Perfect your project management"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.bodytext",
                        defaultMessage:
                            "Plan, track, and measure any project - from simple to complex - to ensure a smooth delivery."
                    })
                }
            ]}
            pictureProps={{
                image: {
                    src: useNewScreenshots
                        ? "https://dam-cdn.atl.orangelogic.com/AssetLink/p75wc0x52sjd6s72ad14u5d3753f84cq/project-management-teams.webp"
                        : "https://dam-cdn.atl.orangelogic.com/AssetLink/ny0k1426i6ykja1nc43x3y2wiu234c3f.webp",
                    alt: "",
                    height: 800,
                    width: 1536
                }
            }}
            tabContentEyebrowText={intl.formatMessage({
                id: "HomePageTemplateV2.tab.projManagement.resources",
                defaultMessage: "Get started with a template"
            })}
            cardsContent={[
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card1.headerText",
                        defaultMessage: "Scrum"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card1.bodyText",
                        defaultMessage:
                            "Easily plan, track, and manage work across sprints"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardOneCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-1.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card2.headerText",
                        defaultMessage: "Kanban"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card2.bodyText",
                        defaultMessage:
                            "Manage a continuous delivery of work on a collaborative board"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardTwoCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-2.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                },
                {
                    headerText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card3.headerText",
                        defaultMessage: "Gantt chart"
                    }),
                    bodyText: intl.formatMessage({
                        id: "HomePageTemplateV2.tab.projManagement.card3.bodyText",
                        defaultMessage:
                            "Visualize timelines, progress, tracking, and dependencies"
                    }),
                    ctaProps: {
                        text: cardCtaText,
                        href: cardThreeCtaUrl,
                        dataEventProps: cardDataEventProps
                    },
                    pictureProps: {
                        image: {
                            src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/projm-card-3.webp",
                            alt: "",
                            height: 215,
                            width: 368
                        }
                    }
                }
            ]}
        />
    );
};

export { ProjectManagementTabContent };
